import { useId } from 'react';
import styles from './XLogo.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function XLogo({ className }) {
	const id = useId();
	const classNameArray = className?.split(' ') || [];

	return (
		<svg className={cx([...classNameArray])} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-describedby={`x-title-${id}`}>
			<title id={`x-title-${id}`}>X</title>
			<path d="M17.269.248h3.286l-7.18 8.205 8.447 11.163h-6.613l-5.179-6.771-5.926 6.771H.816l7.679-8.777L.393.25h6.78l4.681 6.189L17.27.248ZM16.116 17.65h1.82L6.185 2.11H4.23l11.886 15.54Z" fill="#202020" />
		</svg>
	);
}
